import * as types from '../actionTypes/client'

export function getClientsForLobbyist(lobbyistClients) {
  return {
    type: types.GET_CLIENT_FOR_LOBBYIST,
    lobbyistClients
  }
}

export function getClient(client) {
  return {
    type: types.GET_CLIENT,
    client
  }
}

export function updateClientForLobbyist(lobbyistClient) {
  return {
    type: types.UPDATE_CLIENT_FOR_LOBBYIST,
    lobbyistClient
  }
}

export function addClientToLobbyist(lobbyistClient) {
  return {
    type: types.ADD_CLIENT_TO_LOBBYIST,
    lobbyistClient
  }
}

export function removeClientFromLobbyist(clientId) {
  return {
    type: types.REMOVE_CLIENT_FROM_LOBBYIST,
    clientId
  }
}

export function clearClient() {
  return {
    type: types.CLEAR_CLIENT
  }
}

export function clearClientsFromLobbyist() {
  return {
    type: types.CLEAR_CLIENTS_FOR_LOBBYIST
  }
}


// WEBPACK FOOTER //
// ./src/actions/client.js